import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { RouterPath } from "@/router/types";
import { MainButton } from "@/shared/ui/Buttons/MainButton";

export function Buttons() {
  const navigate = useNavigate();
  return (
    <div className="flex-col-gap-2 lgc:flex-row lgc:gap-4">
      <MainButton
        id="home-page-application-submit"
        onClick={() => navigate(RouterPath.Cabinet)}
      >
        <FormattedMessage defaultMessage="Подать заявку" />
      </MainButton>
    </div>
  );
}
